import { create } from "apisauce";
import { BASE_URL, DOMAIN } from "../utils/constants";

export const api = create({
  baseURL: `${BASE_URL}`,
  headers: { Domain: DOMAIN },
});
